// extracted by mini-css-extract-plugin
module.exports = {"body":"Offer_body__Eg82O","container":"Offer_container__1nMeJ"};